// Versión mejorada - Compatible con CSP estricto usando Stimulus Targets
import {Controller} from "stimulus"

export default class extends Controller {
    static targets = ["timer", "resend"]
    static values = {
        timestamp: String
    }

    connect() {
        this.startTimer()

        $(this.resendTarget).on('click', () => {
            $.ajax({
                url: `${location.origin}/2fa/resend`,
                type: 'GET',
                data: {},
                success: (data) => {

                    if(data.success){
                        toastr.success(data.message,'Ok');
                        setTimeout(()=>{
                            location.reload();
                        },1000)
                    }
                }
            })
        })
    }

    disconnect() {
        this.stopTimer()
    }

    startTimer() {
        this.timerInterval = setInterval(() => {
            this.updateTimer()
        }, 1000)
    }

    stopTimer() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval)
        }
    }

    updateTimer() {
        const now = new Date()
        const future = new Date(this.timestampValue)
        const diffMs = future - now
        if (diffMs <= 0) {
            this.stopTimer()
            this.timerTarget.textContent = ""
            this.timerTarget.classList.add('ocultar')
            this.resendTarget.classList.remove('ocultar')
            return
        }

        const totalSeconds = Math.floor(diffMs / 1000)
        const minutes = Math.floor(totalSeconds / 60)
        const seconds = totalSeconds % 60


        if (minutes >= 10) {
            this.stopTimer()
            this.timerTarget.textContent = ""
            this.timerTarget.classList.add('ocultar')
            this.resendTarget.classList.remove('ocultar')
            return
        }


        const formattedMinutes = minutes.toString().padStart(2, '0')
        const formattedSeconds = seconds.toString().padStart(2, '0')


        this.timerTarget.textContent = `${formattedMinutes}:${formattedSeconds}`
    }


}